import { UserRepository } from '../internal/repositories/UserRepository';
import { diContainer, serviceNames } from '../service-setup/diContainer';
import { action } from 'mobx';
import { RouterStore } from '@estee/elc-router';
import { SignUpViewController } from '../internal/controllers/signup/SignUpViewController';

export const QUERY_PARAM_KEY_STORE_ID = 'door';
export const QUERY_PARAM_KEY_TRANSACTION_ID = 'receipt';

export class SignUpFormLoadedUseCase {
    private userRepository: UserRepository;
    private routerStore: RouterStore;
    private signUpViewController: SignUpViewController;

    constructor() {
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.routerStore = diContainer.get(serviceNames.routerStore);
        this.signUpViewController = diContainer.get(serviceNames.signUpViewController);
    }

    @action
    public execute = () => {
        const { userFormStore } = this.userRepository;
        const queryParams = this.routerStore.queryParams;
        const storeId = queryParams[QUERY_PARAM_KEY_STORE_ID];
        const transactionId = queryParams[QUERY_PARAM_KEY_TRANSACTION_ID];
        const { isDefaultExists } = this.signUpViewController;

        if (storeId && isDefaultExists(storeId)) {
            userFormStore.setFieldValue('storeLocation', storeId);
        }

        if (transactionId) {
            userFormStore.setFieldValue('loyaltySignupPosTransId', transactionId);
        }
    };
}
